export enum ContentHubSlugs {
  HOME = 'home-screen',
  SERIES = 'series-screen',
  MOVIES = 'movies-screen',
  SPORTS = 'sports-all-screen',
  BROWSE = 'browse-screen',
}
